<footer class="footer">
  <div class="container footer__inner glass">
    <div class="footer__info" aria-label="Contact">
      <div class="footer__item">
        <span class="footer__muted">{{ 'footer.headquartersLabel' | translate }}</span>
        <span class="footer__value">{{ 'footer.headquartersValue' | translate }}</span>
      </div>
      <div class="footer__item">
        <span class="footer__muted">{{ 'footer.contactNumberLabel' | translate }}</span>
        <a class="footer__value" [href]="whatsappUrl" target="_blank" rel="noopener noreferrer">
          {{ 'footer.contactNumberValue' | translate }}
        </a>
      </div>

      <div class="footer__item">
        <span class="footer__muted">{{ 'footer.email' | translate }}</span>
        <a class="footer__value" [href]="'mailto:' + email">{{ email }}</a>
      </div>
    </div>

    <a class="btn btn-primary footer__btn" [href]="linkedInUrl" target="_blank" rel="noopener noreferrer">
      <span class="footer__icon" aria-hidden="true">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path
            d="M6.94 6.5a2.44 2.44 0 1 1-4.88 0 2.44 2.44 0 0 1 4.88 0ZM2.5 21h4.88V9H2.5v12ZM9.5 9h4.67v1.64h.07c.65-1.17 2.24-2.4 4.6-2.4 4.92 0 5.83 3.1 5.83 7.13V21h-4.88v-4.88c0-1.16-.02-2.65-1.78-2.65-1.78 0-2.05 1.33-2.05 2.56V21H9.5V9Z"
            fill="currentColor"
          />
        </svg>
      </span>
      {{ 'footer.linkedin' | translate }}
    </a>
  </div>
</footer>

